import { InputText } from '../../classes/input-text';
import { InputBase } from '../../classes/input-base';

export class BookForm {
	type: string;

	link = new InputText({
		key: 'link',
		label: 'Book Link',
		required: true,
	});

	title = new InputText({
		key: 'title',
		label: 'Book Title',
		required: true,
	});

	author = new InputText({
		key: 'author',
		label: 'Author',
		required: true,
	});

	description = new InputBase({
		key: 'description',
		label: 'Book Description for Promotion',
		required: false,
		maxLength: 400,
	});

	promoPrice = new InputText({
		key: 'promo_price',
		label: 'Promo Price',
		required: true,
		type: 'number',
	});

	kindleUnlimited = new InputBase({
		key: 'kindleUnlimited',
		label: 'Is your book enrolled in Kindle Unlimited (now Kindle+)?',
		controlType: 'checkbox',
		value: false,
	});

	kindleCountdownDeal = new InputBase({
		key: 'kindleCountdownDeal',
		label: 'Is this a Kindle Countdown Deal?',
		controlType: 'checkbox',
		value: false,
	});

	bookLength = new InputText({
		key: 'bookLength',
		label: 'Page Count (Optional)',
		required: false,
		type: 'number',
		min: 0,
	});

	isSeries = new InputBase({
		key: 'isSeries',
		label: 'Is this a series?',
		controlType: 'checkbox',
		value: false,
	});

	nameOfSeries = new InputText({
		key: 'nameOfSeries',
		label: 'Name of Series',
		required: false,
	});

	numberOfBooksInSeries = new InputText({
		key: 'numberOfBooksInSeries',
		label: 'Total Books in Series',
		required: false,
		type: 'number',
		min: 1,
	});

	bookNumber = new InputText({
		key: 'bookNumber',
		label: 'Position of This Book',
		required: false,
		type: 'number',
		min: 1,
	});

	amazonLink = new InputText({
		key: 'amazonLink',
		label: 'Amazon Link',
		placeholder: 'https://www.amazon.com/dp/B07JZQZQZQ',
	});

	apple = new InputText({
		key: 'apple',
		label: 'Apple Books Link',
		placeholder: 'https://itunes.apple.com/us/book/id123456789',
	});

	nook = new InputText({
		key: 'nook',
		label: 'Nook Link',
		placeholder: 'https://www.barnesandnoble.com/w/123456789',
	});

	kobo = new InputText({
		key: 'kobo',
		label: 'Kobo Link',
		placeholder: 'https://www.barnesandnoble.com/w/123456789',
	});

	googleplay = new InputText({
		key: 'googleplay',
		label: 'Google Play Link',
		placeholder: 'https://www.barnesandnoble.com/w/123456789',
	});

	authorstore = new InputText({
		key: 'authorstore',
		label: 'Author Store Link',
		placeholder: '',
	});

	purchaserInfoEmail = new InputText({
		key: 'purchaserInfoEmail',
		label: 'Email',
		required: true,
	});

	purchaserInfoFirstName = new InputText({
		key: 'purchaserInfoFirstName',
		label: 'First Name',
		required: true,
	});

	purchaserInfoLastName = new InputText({
		key: 'purchaserInfoLastName',
		label: 'Last Name',
		required: true,
	});

	terms = new InputBase({
		key: 'terms',
		label: '???',
		controlType: 'checkbox',
		value: false,
	});

	subscribe = new InputBase({
		key: 'subscribe',
		label: this.createSubscribeLabel(),
		controlType: 'checkbox',
		value: false,
	});

	constructor(type) {
		this.type = type;
	}

	createSubscribeLabel() {
		if (this.type === 'promostack') {
			return `Want to see what your readers see? Toggle "Yes" to opt in to the reader email list(s) for the sites in this 
		stack so you can see your promos when they run!`;
		}

		return 'Add me to the reader list for this site so I can see my promo when it runs! (Highly Recommended)';
	}
}
